import Container from 'react-bootstrap/Container';
import React, { Fragment } from 'react';
import Header from './components/Header';

const NotFound = () => (
  <Fragment>
    <Header />
    <Container className="mt-4">
      <div className="shadow px-3 py-4 mb-5 bg-white">
        <h3 className="font-weight-bold">Not Found</h3>
        <h5 className="mt-4">Sorry, we can't find the page you were looking for.</h5>
      </div>
    </Container>
  </Fragment>
);

export default NotFound;
